import { render, staticRenderFns } from "./SelectParts.vue?vue&type=template&id=7afc0e92&scoped=true&lang=pug&"
import script from "./SelectParts.vue?vue&type=script&lang=ts&"
export * from "./SelectParts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc0e92",
  null
  
)

export default component.exports